"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _utils = require("@/utils");
var _product = require("@/api/product");
var _permission = require("@/utils/permission");
var _refundOrderDetail = _interopRequireDefault(require("../components/refundOrderDetail.vue"));
var _filters = require("@/filters");
var _useRefundOrder2 = _interopRequireDefault(require("@/libs/useRefundOrder"));
var _agreeToReturn = _interopRequireDefault(require("@/views/order/components/agreeToReturn.vue"));
var $constants = _interopRequireWildcard(require("@/utils/constants"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

var _useRefundOrder = (0, _useRefundOrder2.default)(),
  onConfirmReceipt = _useRefundOrder.onConfirmReceipt,
  onApprovedReview = _useRefundOrder.onApprovedReview;
var tableFroms = {
  refundStatus: '9',
  dateLimit: '',
  orderNo: '',
  refundOrderNo: '',
  page: 1,
  limit: $constants.page.limit[0],
  searchType: 'all',
  content: '',
  trackingNumber: ''
};
// 权限判断函数
var _default = exports.default = {
  name: 'orderRefund',
  components: {
    AgreeToReturn: _agreeToReturn.default,
    RefundOrderDetail: _refundOrderDetail.default
  },
  data: function data() {
    return {
      datekey: Date.now(),
      RefuseData: {},
      refundOrderNo: '',
      //退款单号
      refundData: {},
      tableDataLog: {
        data: [],
        total: 0
      },
      LogLoading: false,
      isCreate: 1,
      editData: null,
      dialogVisible: false,
      tableData: {
        data: [],
        total: 0
      },
      listLoading: true,
      tableFrom: Object.assign({}, tableFroms),
      orderChartType: {},
      timeVal: [],
      fromList: this.$constants.fromList,
      selectionList: [],
      ids: '',
      orderids: '',
      cardLists: [],
      isWriteOff: (0, _utils.isWriteOff)(),
      proType: 0,
      active: false,
      card_select_show: false,
      checkAll: true,
      checkedCities: ['退款单号', '订单号', '用户昵称', '退款金额', '退款状态', '售后类型', '退货类型', '强制退款', '创建时间'],
      columnData: ['退款单号', '订单号', '用户昵称', '退款金额', '退款状态', '售后类型', '退货类型', '强制退款', '创建时间'],
      isIndeterminate: false,
      dialogVisibleAgreeToReturn: false,
      refundInfo: null,
      drawerVisible: false,
      tagClass: ['doingTag', 'notStartTag', 'doingTag', 'endTag', 'notStartTag', 'doingTag', 'endTag']
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:refund:order:page:list'])) this.getList();
    if ((0, _permission.checkPermi)(['merchant:refund:order:status:num'])) this.getOrderStatusNum();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //商家确认收货
    handleConfirmReceipt: function handleConfirmReceipt(refundOrderNo) {
      var _this = this;
      onConfirmReceipt(refundOrderNo).then(function () {
        _this.handleSearchList();
      });
    },
    //审核同意
    handleApprovedReview: function handleApprovedReview(row) {
      var _this2 = this;
      if (row.returnGoodsType !== 1) {
        onApprovedReview({
          auditType: 'success',
          refundOrderNo: row.refundOrderNo
        }).then(function () {
          _this2.handleSearchList();
        });
      } else {
        //退货退款
        this.refundInfo = row;
        this.dialogVisibleAgreeToReturn = true;
      }
    },
    //审核成功回调
    handleSuccess: function handleSuccess() {
      this.dialogVisibleAgreeToReturn = false;
      this.handleSearchList();
    },
    //同意弹窗
    handleCloseAgreeToReturn: function handleCloseAgreeToReturn() {
      this.dialogVisibleAgreeToReturn = false;
    },
    //审核拒绝
    handleOrderRefuse: function handleOrderRefuse(row) {
      var _this3 = this;
      this.$modalPrompt('textarea', '拒绝退款原因', null).then(function (V) {
        (0, _order.orderAuditApi)({
          auditType: 'refuse',
          reason: V,
          refundOrderNo: row.refundOrderNo
        }).then(function () {
          _this3.$message.success('审核成功');
          _this3.handleSearchList();
        });
      });
    },
    //拒绝收货
    handleRefuseReceipt: function handleRefuseReceipt(row) {
      var _this4 = this;
      this.$modalPrompt('textarea', '拒绝收货原因', null).then(function (V) {
        (0, _order.refundOrderReceivingRejectApi)({
          reason: V,
          refundOrderNo: row.refundOrderNo
        }).then(function () {
          _this4.$message.success('拒绝收货成功');
          _this4.handleSearchList();
        });
      });
    },
    //重置
    handleReset: function handleReset() {
      this.tableFrom.dateLimit = '';
      this.tableFrom.orderNo = '';
      this.tableFrom.refundOrderNo = '';
      this.tableFrom.content = '';
      this.tableFrom.searchType = 'all';
      this.tableFrom.trackingNumber = '';
      this.selectChange();
    },
    //搜索
    handleSearchList: function handleSearchList() {
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    onClosedrawerVisible: function onClosedrawerVisible() {
      this.drawerVisible = false;
    },
    //详情中审核成功回调
    getReviewSuccessful: function getReviewSuccessful() {
      this.handleSearchList();
    },
    // 详情
    onOrderDetails: function onOrderDetails(row) {
      this.refundOrderNo = row.refundOrderNo;
      this.drawerVisible = true;
    },
    // 备注
    onOrderMark: function onOrderMark(row) {
      var _this5 = this;
      this.$modalPrompt('textarea', '备注', row.merRemark, '退款单备注').then(function (V) {
        (0, _order.refundMarkApi)({
          remark: V,
          refundOrderNo: row.refundOrderNo
        }).then(function () {
          _this5.$message.success('操作成功');
          _this5.getList();
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectionList = val;
      var data = [];
      this.selectionList.map(function (item) {
        data.push(item.orderNo);
      });
      this.ids = data.join(',');
    },
    // 选择时间
    selectChange: function selectChange(tab) {
      this.timeVal = [];
      this.tableFrom.page = 1;
      this.handleSearchList();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.handleSearchList();
    },
    // 列表
    getList: function getList() {
      var _this6 = this;
      this.listLoading = true;
      (0, _order.refundListApi)(this.tableFrom).then(function (res) {
        _this6.tableData.data = res.list || [];
        _this6.tableData.total = res.total;
        _this6.listLoading = false;
        _this6.checkedCities = _this6.$cache.local.has('order_refund_stroge') ? _this6.$cache.local.getJSON('order_refund_stroge') : _this6.checkedCities;
      }).catch(function () {
        _this6.listLoading = false;
      });
    },
    // 获取各状态数量
    getOrderStatusNum: function getOrderStatusNum() {
      var _this7 = this;
      var data = Object.assign({}, this.tableFrom);
      delete data.page;
      delete data.limit;
      delete data.refundStatus;
      (0, _order.refundStatusNumApi)(data).then(function (res) {
        _this7.orderChartType = res;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    exports: function exports() {
      var data = {
        dateLimit: this.tableFrom.dateLimit,
        orderNo: this.tableFrom.orderNo,
        refundStatus: this.tableFrom.status,
        type: this.tableFrom.type
      };
      (0, _product.orderExcelApi)(data).then(function (res) {
        window.open(res.fileName);
      });
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.$set(this, 'card_select_show', false);
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('order_refund_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    },
    //打印小票
    onOrderPrint: function onOrderPrint(data) {
      var _this8 = this;
      (0, _order.orderPrint)(data.orderNo).then(function (res) {
        _this8.$modal.msgSuccess('打印成功');
      }).catch(function (error) {
        _this8.$modal.msgError(error.message);
      });
    }
  }
};